import React, { useState } from 'react';
import DialogComponent from '../common/Dialog/DialogComponent';
import MenuComponent from '../common/Menu/Menu';
import About from './About';
import { useTranslation } from 'react-i18next';

const Header = ({ headerIcon }) => {
  const [activeMenu, setActiveMenu] = useState('help');
  const [anchorEl, setAnchorEl] = useState(null);
  const [aboutModel, setAboutModel] = useState(false);

  const openMenu = event => setAnchorEl(event.currentTarget);

  const closeMenu = () => setAnchorEl(null);

  const { t } = useTranslation();
  const tc = e => t(`menu:${e}`);

  const helpMenuList = [
    { name: tc('MENU_ABOUT'), type: 'subMenu' },
    {
      name: `${tc('MENU_ABOUT')} ${tc('MENU_PLANNING_MAESTRO')}`,
      type: 'menuItem',
      clickEvent: 'aboutPM',
      icon: 'info_outline',
    },
  ];

  const getClickEvent = eventName => {
    closeMenu();
    switch (eventName) {
      case 'aboutPM':
        setAboutModel(true);
        break;
      default:
        return null;
    }
  };

  const closeAboutModel = () => setAboutModel(false);

  return (
    <div className="react-header header">
      <div className="logo">
        <i className={`${headerIcon ? headerIcon : 'icon-centage-primary-logo'} react-header-logo-text`}></i>
      </div>
      <div className="header-top-menu">
        <ul className="header-top-menu-container">
          <li className="header-top-menu-item">
            <a
              href="#"
              title="Help"
              className="no-underline"
              aria-controls={activeMenu}
              aria-haspopup="true"
              onClick={openMenu}
              style={{ borderColor: anchorEl ? '#fff' : 'transparent' }}>
              <i className="icon-questionmark"></i>
            </a>
          </li>
          {activeMenu && activeMenu.length ? (
            <MenuComponent activeMenu={activeMenu} anchorEl={anchorEl} handleClose={closeMenu} className="header-menu">
              {helpMenuList.map((item, i) => {
                const { name, type, clickEvent, icon } = item;
                return (
                  <li
                    key={i}
                    className={type == 'subMenu' ? 'header-menu-title' : type == 'menuItem' ? 'header-menu-item' : ''}
                    onClick={() => getClickEvent(clickEvent)}
                    title={name}>
                    {icon ? (
                      <span>
                        <i className="material-icons">{icon}</i>
                      </span>
                    ) : (
                      ''
                    )}
                    {name}
                  </li>
                );
              })}
            </MenuComponent>
          ) : (
            ''
          )}
          <DialogComponent open={aboutModel} handleClose={closeAboutModel} className="react-dialog">
            <About />
          </DialogComponent>
        </ul>
      </div>
    </div>
  );
};

export default Header;